import type {} from "@lit/react";
import { Item as ItemElement, } from "@vaadin/item/vaadin-item.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ItemElement, };
export type ItemEventMap = Readonly<{}>;
const events = {} as ItemEventMap;
export type ItemProps = WebComponentProps<ItemElement, ItemEventMap>;
export const Item = createComponent({
    elementClass: ItemElement, events, react: React, tagName: "vaadin-item"
});
